<div class="modal-body">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="phone-number-block d-flex align-items-center mb-15">
    <span>Phone:</span><span id="phoneNumber">{{ model.phone }}</span>
    <a (click)="copyPhoneNumberToClipboard()" tabindex="0" (keydown.enter)="copyPhoneNumberToClipboard()" class="ms-0_5 d-inline-block mt-0_2"
      ><span class="icon-copy"></span
    ></a>
  </div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="mb-20">
    <input [(ngModel)]="model.phone" formControlName="phone" class="form-control" type="text" hidden />
    <div class="form-group mb-20">
      <span class="radio-title">Issue</span>
      <div class="form-check mb-15" *ngFor="let item of issues">
        <input class="form-check-input" type="radio" [value]="item.id" [(ngModel)]="model.issue" formControlName="issue" />
        <label class="form-check-label cp" tabindex="0" (keydown.enter)="model.issue = item.id" (click)="model.issue = item.id">
          {{ item.label }}
        </label>
      </div>
    </div>

    <div class="form-group">
      <label for="number" class="form-label">Description</label>
      <textarea [(ngModel)]="model.description" formControlName="description" class="form-control" placeholder="Type comment" rows="3"></textarea>
    </div>
  </form>
</div>
<div class="modal-footer pt-15">
  <div class="button-holder d-flex justify-content-between">
    <button class="btn btn-outline-dark" (click)="afterSave.emit()">Cancel</button>
    <button class="btn btn-primary ms-15" (click)="onSubmit()" [disabled]="!form.valid">Send Report</button>
  </div>
</div>
